export default __webpack_public_path__ + "static/media/search.5307c55a.svg";